<script>
import OptionBuilder from './Builder.vue';
export default {
    components: {
        OptionBuilder
    },

    props: {
        text: {
            type: String,
            required: true
        },

        disabled: {
            type: Boolean,
            default: false
        }
    }, 

    mounted() {
        Bus.$on('clickToSummarize', () => {
            this.handleClick(false);
        });
    },

    methods: {
        handleClick(showOptions = true) {
            if (this.text == null || this.text == '' || this.stripHtml(this.text) == '') {
                Bus.$emit('selliaActionResponse', {type: 'info', message: this.__('Por favor, adicione um texto primeiro.'), timeout: 5000});
                return;
            }

            if (showOptions) {
                Bus.$emit('selliaOptionBuilderClick', 'summarize');
            }

            Bus.$emit('selliaActionResponse', {type: 'action', message: this.__('Escrevendo...'), timeout: 5000});
            this.$http.post('/integration/ai/summarize', {
                text: this.text
            }).then(response => {
                Bus.$emit('insertSummarizedTextToTextarea', response.data.summary);
                Bus.$emit('selliaActionResponse', {type: 'hidden', message: this.__('Resumo concluído! Agora, é sua vez. Lembre-se de salvar!'), timeout: 5000});
            }).catch(error => {
                console.log({
                    error: error,
                    status: error.status,
                    text: error.body.text,
                });

                Bus.$emit('selliaActionResponse', {type: 'info', message: null, timeout: 500});

                if (error.status == 422) {
                    return Alert.warning(error.body.text);
                }
                
                if (error.status == 503) {
                    return Alert.error(error.body.error);
                }

                return Alert.error(this.__('Erro na solicitação junto a SelliA, aguarde e tente novamente.'));
            }).finally(() => {
                Bus.$emit('selliaOptionBuilderClickFinished', 'summarize');
            });
        },

        stripHtml(html) {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return doc.body.textContent.trim();
        }
    }
}
</script>

<template>
    <OptionBuilder 
        ref="summarizeOb"
        optionName="Resumir texto" 
        iconName="TwoFourPointedStar" 
        id="summarize" 
        bottom="64"
        :disabled="disabled"
        @selliaOptionBuilderClickSummarize="handleClick"
    />
</template>
